export default "__VITE_ASSET__Cugs8JwN__"